import { useCallback } from "react";
import localstory from "localstory";
export default function useOfferCartOrderData() {
    const keyName = "offer_cart_order_data";
    const storage = localstory(window.localStorage, "flights", { ttl: "30m" });
    const save = useCallback((token, data) => {
        const allItems = storage.get(keyName) || [];
        const newData = allItems.filter(({ offer, cart, order }) => (!offer || offer !== data.offer) &&
            (!cart || cart !== data.cart) &&
            (!order || order !== data.order) &&
            ![offer, cart, order].filter(Boolean).includes(token));
        newData.push(data);
        storage.set(keyName, newData);
    }, [storage]);
    const get = useCallback((token) => {
        if (!token)
            return {};
        const allItems = storage.get(keyName) || [];
        const result = allItems.find((i) => [i.offer, i.cart, i.order].filter(Boolean).includes(token)) || {};
        return result;
    }, [storage]);
    const set = useCallback((token, data) => {
        if (!token)
            return;
        const currentData = get(token);
        const mergedData = { ...currentData, ...data };
        const { offer, cart, order } = mergedData;
        if (![offer, cart, order].filter(Boolean).length)
            return;
        save(token, mergedData);
    }, [get, save]);
    return { set, get };
}
